import Vue from "vue"

//'toasted-primary', 'outline', 'bubble Types: 'success, info, error
//auth success messages
export const logginSuccess = () => Vue.toasted.show('authenticated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end auth success messages

//role
export const roleCreateSuccess = () => Vue.toasted.show('role created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleUpdateSuccess = () => Vue.toasted.show('role updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const roleDeleteSuccess = () => Vue.toasted.show('role deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end role


//role modules
export const moduleCreateSuccess = () => Vue.toasted.show('module created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const moduleDeleteSuccess = () => Vue.toasted.show('module deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end modules

//permissions
export const permissionCreateSuccess = () => Vue.toasted.show('permission created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const permissionDeleteSuccess = () => Vue.toasted.show('permission deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end permissions

//user
export const userCreateSuccess = () => Vue.toasted.show('user created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userUpdateSuccess = () => Vue.toasted.show('user updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const userDeleteSuccess = () => Vue.toasted.show('user deleted successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignUserRoleModelSuccess = () => Vue.toasted.show('user asigned role module successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const asignRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions asigned successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const removedRoleModulePermissionsSuccess = () => Vue.toasted.show('permissions removed successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'info' });
export const uploadProfilePicSuccess = () => Vue.toasted.show('profile picture uploaded successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end users


//product

//role
export const productCreateSuccess = () => Vue.toasted.show('product created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const productUpdateSuccess = () => Vue.toasted.show('product updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end product

//stock
export const stockCreateSuccess = () => Vue.toasted.show('stock created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const stockUpdateSuccess = () => Vue.toasted.show('stock updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end stock


//transporters
export const transporterCreateSuccess = () => Vue.toasted.show('transporter created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const transporterUpdateSuccess = () => Vue.toasted.show('transporter updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end transporters

//trucks
export const truckCreateSuccess = () => Vue.toasted.show('transporter truck created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const truckUpdateSuccess = () => Vue.toasted.show('transporter truck updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end trucks

//accounttypes
export const accounttypeCreateSuccess = () => Vue.toasted.show('account type created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const accounttypeUpdateSuccess = () => Vue.toasted.show('account type updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end accounttypes

//pettycash
export const pettycashCreateSuccess = () => Vue.toasted.show('petty cash amount created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end petty cash

//purchase orders
export const purchaseorderCreateSuccess = () => Vue.toasted.show('purchaseorder created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end purchase orders

//goods receiving note
export const goodsreceivingnoteCreateSuccess = () => Vue.toasted.show('goods receiving noted created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const goodsreceivingnoteUpdateSuccess = () => Vue.toasted.show('goods receiving noted updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end goods receiving note

//purchases
export const purchasesCreateSuccess = () => Vue.toasted.show('purchases created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end purchases

//sales
export const salesCreateSuccess = () => Vue.toasted.show('sales created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end sales

//expenses
export const expensesCreateSuccess = () => Vue.toasted.show('expenses created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end expenses

//labours
export const laboursCreateSuccess = () => Vue.toasted.show('labour charges created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const laboursUpdateSuccess = () => Vue.toasted.show('labour charges update successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end labours

//interchanges
export const interchangesCreateSuccess = () => Vue.toasted.show('interchanges created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end interchanges

//employees
export const employeeCreateSuccess = () => Vue.toasted.show('employee created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const employeeUpdateSuccess = () => Vue.toasted.show('employee  updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end employees


//attendances
export const attendanceCreateSuccess = () => Vue.toasted.show('attendances created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
export const attendanceUpdateSuccess = () => Vue.toasted.show('attendances  updated successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end attendances


//invoices
export const invoicesCreateSuccess = () => Vue.toasted.show('invoices created successful!!',{ icon : 'check',theme: "outline",position: "top-right", type:'success' });
//end invoices


// WEBPACK FOOTER //
// ./src/successmessages/success.js